(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outeq-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-outeq-popup]');
    if (!root) return;

    const overlay = root.querySelector('[data-outeq-popup-overlay]');
    const modal = root.querySelector('[data-outeq-popup-modal]');
    const tab = root.querySelector('[data-outeq-popup-tab]');
    const tabOpen = root.querySelector('[data-outeq-popup-tab-open]');
    const tabDismissBtn = root.querySelector('[data-outeq-popup-tab-dismiss]');
    const formState = root.querySelector('[data-outeq-popup-form-state]');
    const successState = root.querySelector('[data-outeq-popup-success-state]');
    const code = root.querySelector('[data-outeq-popup-code]');
    const copied = root.querySelector('[data-outeq-popup-copied]');

    const KEY = 'outeqPopupState'; // '', 'closed', 'done'
    const state = () => localStorage.getItem(KEY) || '';
    const setState = (v) => localStorage.setItem(KEY, v);

    const TAB_KEY = 'outeqPopupTabDismissed_v2'; // verze klíče: reset starých dismissů
    const tabDismissed = () => localStorage.getItem(TAB_KEY) === '1';
    const showTab = () => { if (!tabDismissed()) tab.hidden = false; };

    const open = () => {
      overlay.hidden = false;
      modal.hidden = false;
      tab.hidden = true;
      requestAnimationFrame(() => {
        overlay.classList.add('is-visible');
        modal.classList.add('is-visible');
      });
      modal.querySelector('input[type="email"], [data-outeq-popup-code]')?.focus?.();
    };

    const close = () => {
      overlay.classList.remove('is-visible');
      modal.classList.remove('is-visible');
      setTimeout(() => {
        overlay.hidden = true;
        modal.hidden = true;
      }, 250);
      if (state() !== 'done') setState('closed');
      // po zavření se nabídka přilepí k boku stránky (pokud ji uživatel nezavřel křížkem)
      showTab();
    };

    const showSuccess = () => {
      formState.hidden = true;
      successState.hidden = false;
    };

    // Úspěšná registrace. Hlavní zdroj je server (form.posted_successfully?),
    // parametr v URL je záloha — Shopify na úspěch přesměruje s
    // ?customer_posted=true, takže kód se ukáže i při návratu z historie.
    const postedByUrl = new URLSearchParams(location.search).get('customer_posted') === 'true';
    if (root.dataset.posted === 'true' || postedByUrl) {
      setState('done');
      showSuccess();
      open();
    } else if (state() === 'done') {
      showSuccess();
      showTab(); // kód si může znovu zobrazit
    } else if (state() === 'closed') {
      showTab();
    } else {
      // nový návštěvník: lišta je vidět hned; popup se otevře po prodlevě
      // (a lištu dočasně skryje), po zavření se lišta zase ukáže.
      showTab();
      const delay = (parseInt(root.dataset.delay, 10) || 3) * 1000;
      setTimeout(() => {
        if (!state()) open();
      }, delay);
    }

    root.querySelector('[data-outeq-popup-close]').addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
    tabOpen.addEventListener('click', open);
    tabDismissBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      tab.hidden = true;
      localStorage.setItem(TAB_KEY, '1');
    });

    if (code) {
      const copy = () => {
        navigator.clipboard?.writeText(code.textContent.trim()).then(() => {
          if (copied) copied.textContent = copied.dataset.copiedText || 'Copied';
        });
      };
      code.addEventListener('click', copy);
      code.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copy(); }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
